
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 1000"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M500 990C229.4 990 10 770.6 10 500S229.4 10 500 10s490 219.4 490 490-219.4 490-490 490zm0-946.8C247.7 43.2 43.2 247.7 43.2 500S247.7 956.8 500 956.8 956.8 752.3 956.8 500 752.3 43.2 500 43.2zm240.8 664.4h-465c-18.4 0-33.2-13.7-33.2-30.7V339.6c0-16.9 14.9-30.7 33.2-30.7h465.1c18.4 0 33.2 13.7 33.2 30.7V677c0 16.9-14.9 30.6-33.3 30.6zm0-368h-465v1l234.1 216 231-213.3v-3.7zm0 47.2L526.2 585h-32.7L275.8 384v293h465.1V386.8z"}})])
          )
        }
      }
    